<template>
  <BaseModal name="managerContractsModal" width="420" :clickToClose="false" :shiftY="0.5" @before-close="() => { }"
    @before-open="openModal" :adaptive="true" height="320" classes="bg-transparent shadow-none">
    <div
      class="modal-base-content modal-content py-20 h-100 px-30 rounded-25 bg-white position-relative overflow-hidden">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div class="d-flex justify-content-end">
        <slot name="modal-header"></slot>
        <button type="button" class="btn-close" @click="$modal.hide('managerContractsModal')"></button>
      </div>
      <div
        class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center container-with-input"
        v-if="managerList.length">
        <p class="fw-bold mb-15 text-center">Менеджер договора</p>
        <!-- @input="(data) => updateValue({name: 'employeeId', value: })" -->
        <BaseSelect style="width: 100%" placeholder=""
          @input="(data) => updateValue({ name: 'employeeId', value: data.id })" selectLabel="" deselectLabel=""
          v-model="managerValue" :options="managerList" openDirection="bottom" :maxHeight="200" label="name">
          <template slot="noOptions">{{ dataLang['select_empty'] }}</template>
          <template slot="noResult">{{
            dataLang['select_search_empty']
            }}</template><template slot="selectedLabel">{{
              dataLang['select_selected']
            }}</template>
          <template slot="deselectLabel">{{
            dataLang['select_unselect']
            }}</template>
        </BaseSelect>
        <div class="d-flex justify-content-end gap-30 mt-30">
          <div @click="sendData"
            class="btn btn-sm btn-primary action-hover px-20 rounded-5 d-flex align-items-center justify-content-center text-uppercase py-10">
            {{ dataLang['city_delivery_register_text_35'] }}
          </div>
          <div @click="$modal.hide('managerContractsModal')"
            class="btn btn-sm py-10 btn-opposite px-30 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
            {{ dataLang['global_ui_sign__btn_cancel'] }}
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import GeneralService from '@/api/GeneralService.js'
import { VeTable } from 'vue-easytable'

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable
  },
  data() {
    return {
      managerList: [],
      managerValue: [],
      localLoading: false,
      dataForEmit: {},
      contractId: null
    }
  },
  methods: {
    openModal(paramsOpen) {
      this.contractId = paramsOpen.params.id
      this.localLoading = true
      GeneralService.get(`/contracts/${this.contractId}/employee`)
        .then((data) => {
          this.managerList = data.data.data
          this.managerValue = data.data.data.filter(
            (x) => paramsOpen.params.employee_name == x.name
          )
          this.localLoading = false
        })
        .catch((e) => { })
    },
    beforeClose(event) {
      this.dataForEmit = {}
      this.managerList = []
      this.managerValue = []
      this.contractId = null
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value
    },
    sendData() {
      if (Object.keys(this.dataForEmit).length) {
        this.localLoading = true
        GeneralService.editOrCreate(`/contracts/${this.contractId}/employee`, {
          ...this.dataForEmit
        })
          .then((data) => {
            this.$toast.success(data.data.message)
            this.dataForEmit = {}
            this.$emit('update')
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 })
          })
          .finally(() => {
            this.$modal.hide('managerContractsModal')
            this.localLoading = false
          })
      }
    }
  },
  mounted() { },
  created() { },
  beforeDestroy() { },

  computed: {
    ...mapState('translationModule', ['dataLang'])

    //     {
    //     "sms_presets__category_id": 2,
    //     "sms_presets__company_id": 2,
    //     "sms_presets__created_at": "2024-01-19 08:36:52",
    //     "sms_presets__id": 6,
    //     "sms_presets__name": "третий",
    //     "sms_presets__text": "Не пользуйтесь нашими услугами",
    //     "sms_presets__updated_at": "2024-01-19 11:36:52"
    // }
  }
}
</script>
